import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import Layout from '../../components/UI/Layout/Layout';
import TransformerDataComponent from '../../components/TransformerDataComponents/TransformerDataComponent';
import LocalizedStrings from '../../assets/data/LocalizedStrings/LocalizedStrings.json';

class TransformerDataPage extends Component {
  goBackHandler = () => {
    this.props.history.push('/');
  };

  render() {
    const {
      country,
      language,
      selectedUSA,
      selectedCanadaEN,
      selectedCanadaFR
    } = this.props;

    return (
      <Layout
        title={LocalizedStrings[language].transformerData}
        clicked={this.goBackHandler}
        country={country}
        language={language}
        selectedCanadaEN={selectedCanadaEN}
        selectedCanadaFR={selectedCanadaFR}
        selectedUSA={selectedUSA}
        wideHeading={language === 'fr' ? 'true' : null}
      >
        <TransformerDataComponent country={country} language={language} />
      </Layout>
    );
  }
}

TransformerDataPage.propTypes = {
  language: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  selectedCanadaEN: PropTypes.func,
  selectedCanadaFR: PropTypes.func,
  selectedUSA: PropTypes.func
};

export default withRouter(TransformerDataPage);
